import axios from "axios";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  ListGroup,
  Form,
  Button,
  Col,
  Row,
  Tab,
  InputGroup,
} from "react-bootstrap";
import ConfirmationDialog from "../common/dialog/ConfirmationDialog";
import Notification from "../common/dialog/Notification";
import { handleLogout } from "../layout/Header";
import { getUserState } from "../../app/selector";
import { BACKEND_URL } from "constants";

const Settings = () => {
  const { user } = useSelector(getUserState);
  const navigate = useNavigate();

  const [newInput, setNewInput] = useState("");
  const [confirmInput, setConfirmInput] = useState("");

  const [sendEnabled, setSendEnabled] = useState(false);
  const [show, setShow] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [success, setSuccess] = useState(true);
  const [responseMessage, setResponseMessage] = useState({
    msg: undefined,
    cals: undefined,
  });
  const [enteredPassword, setEnteredPassword] = useState("");
  const [requirePassword, setRequirePassword] = useState(true);
  const [activeTap, setActiveTap] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Safely manage sidebar navigation updates inside a dedicated side-effect loop
  useEffect(() => {
    if (!requirePassword && activeTap === "admin") {
      navigate("/admin");
    }
  }, [requirePassword, activeTap, navigate]);

  // Automatically hide the message after 2 seconds
  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [showMessage]);

  const handleNewInputChange = (event) => {
    const newInputValue = event.target.value;
    setNewInput(newInputValue);
    setSendEnabled(newInputValue === confirmInput);
  };

  const handleConfirmInputChange = (event) => {
    const confirmInputValue = event.target.value;
    setConfirmInput(confirmInputValue);
    setSendEnabled(confirmInputValue === newInput);
  };

  const handleDeleteAccount = (event) => {
    const newInputValue = event.target.value;
    setNewInput(newInputValue);
    setSendEnabled(newInputValue.localeCompare("delete") === 0);
  };

  const handleEnteredPassword = (event) => {
    setEnteredPassword(event.target.value);
  };

  const handleSave = (event) => {
    event.preventDefault();
    if (sendEnabled) {
      setShow(true);
    }
  };

  const checkPassword = (e) => {
    e.preventDefault();

    axios
      .post(BACKEND_URL + "/check-password", {
        enteredPassword: enteredPassword,
      })
      .then(function (response) {
        if (response.status === 200) {
          setRequirePassword(false);
          setResponseMessage({
            msg: "Password is correct ",
            cals: "success",
          });
          setShowMessage(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setResponseMessage({
              msg: "Incorrect password. Please try again.",
              cals: "danger",
            });
          } else if (error.response.status === 400) {
            setResponseMessage({
              msg: "Bad request. Please check your input.",
              cals: "danger",
            });
          } else {
            setResponseMessage({
              msg: "An error occurred. Please try again later.",
              cals: "danger",
            });
          }
        } else if (error.request) {
          setResponseMessage({
            msg: "No response from server. Please check your network connection.",
            cals: "danger",
          });
        } else {
          setResponseMessage({
            msg: "Error: " + error.message,
            cals: "danger",
          });
        }
        setShowMessage(true);
        console.error(error);
      });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function passwordFormControll() {
    return (
      <Form onSubmit={checkPassword}>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm="4">
            <b>Current Password :</b>
          </Form.Label>
          <Col sm="8">
            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="please enter current password"
                value={enteredPassword}
                onChange={handleEnteredPassword}
                required
              />
              <InputGroup.Text>
                <Button
                  onClick={togglePasswordVisibility}
                  type="button"
                  variant="link"
                >
                  {showPassword ? "Hide" : "Show"}
                </Button>
              </InputGroup.Text>
            </InputGroup>
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Button type="submit" variant="outline-primary">
            Apply
          </Button>
        </Form.Group>
      </Form>
    );
  }

  let activePlaceholder = "please type a new " + activeTap + " !";

  function getTypeOfFormControl(type) {
    switch (type) {
      case "email":
        return "email";
      case "age":
      case "postcode":
        return "number";
      default:
        return "text";
    }
  }

  function editFormControll() {
    return (
      <Form onSubmit={handleSave}>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm="4">
            <b>New {activeTap}</b>
          </Form.Label>
          <Col sm="8">
            <Form.Control
              type={getTypeOfFormControl(activeTap)}
              placeholder={activePlaceholder}
              value={newInput}
              onChange={handleNewInputChange}
              required
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} className="mb-3">
          <Form.Label column sm="4">
            <b>Confirm {activeTap}</b>
          </Form.Label>
          <Col sm="8">
            <Form.Control
              type={getTypeOfFormControl(activeTap)}
              placeholder={activePlaceholder}
              value={confirmInput}
              onChange={handleConfirmInputChange}
              required
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row}>
          <Button
            type="submit"
            variant="outline-primary"
            disabled={!sendEnabled}
          >
            Save
          </Button>
        </Form.Group>
      </Form>
    );
  }

  function deleteAccount() {
    return (
      <Form onSubmit={handleSave}>
        <Form.Group as={Row}>
          <Form.Label className="mb-3">
            To delete your account, please type <b> "delete"</b> in the box
            below:
          </Form.Label>
          <Form.Control
            className="mb-3"
            type="text"
            placeholder="please type here !"
            value={newInput}
            onChange={handleDeleteAccount}
            required
          />
          <Button
            type="submit"
            variant="outline-primary"
            disabled={!sendEnabled}
          >
            Confirm
          </Button>
        </Form.Group>
      </Form>
    );
  }

  const handleConfirm = () => {
    axios
      .post(BACKEND_URL + "/settings", {
        activeTap: activeTap,
        newInput: newInput,
      })
      .then(function () {
        setSuccess(true);
        setShowNotification(true);
      })
      .catch(function (error) {
        setSuccess(false);
        setShowNotification(true);
        console.error(error);
      });
  };

  const handleActiveTap = (tap) => {
    setActiveTap(tap);
    setRequirePassword(true); // Reset validation state on swap
    resetInputs();
  };

  function resetInputs() {
    setEnteredPassword("");
    setResponseMessage({
      msg: undefined,
      cals: undefined,
    });
    setNewInput("");
    setConfirmInput("");
  }

  const onClose = () => {
    if (success) {
      handleLogout();
    }
  };

  function capitalizeFirstLetter(string) {
    return string !== undefined
      ? string.charAt(0).toUpperCase() + string.slice(1)
      : null;
  }

  return (
    <div className="content-block bg-light p-3 rounded">
      <ConfirmationDialog
        text={
          activeTap === "delete"
            ? "Are you sure you want to permanently delete your account?"
            : "Are you sure you want to change " + activeTap + "?"
        }
        show={show}
        setShow={setShow}
        operation="Confirm"
        variant="success"
        onConfirm={handleConfirm}
      />
      <Notification
        text={
          success
            ? activeTap === "delete"
              ? "Your Account has been deleted! Thanks for being part of our community!"
              : capitalizeFirstLetter(activeTap) + " has changed! User will be logged out."
            : capitalizeFirstLetter(activeTap) + " already exists!"
        }
        variant={success ? "secondary" : "danger"}
        show={showNotification}
        setShow={setShowNotification}
        onClose={onClose}
      />
      <h1 className="mb-4 title" style={{ textAlign: "center" }}>
        Settings
      </h1>
      <div>
        <Tab.Container id="list-group-tabs-example">
          <Row>
            <Col xs={12} sm={3} className="mb-3">
              <ListGroup>
                <ListGroup.Item action href="#link1" onClick={() => handleActiveTap("username")}>
                  <b>Username</b>
                </ListGroup.Item>
                <ListGroup.Item action href="#link2" onClick={() => handleActiveTap("email")}>
                  <b>E-Mail</b>
                </ListGroup.Item>
                <ListGroup.Item action href="#link3" onClick={() => handleActiveTap("password")}>
                  <b>Password</b>
                </ListGroup.Item>
                <ListGroup.Item action href="#link4" onClick={() => handleActiveTap("age")}>
                  <b>Age</b>
                </ListGroup.Item>
                <ListGroup.Item action href="#link5" onClick={() => handleActiveTap("state")}>
                  <b>State</b>
                </ListGroup.Item>
                <ListGroup.Item action href="#link6" onClick={() => handleActiveTap("upgrade")}>
                  <b>Upgrade Pro Version</b>
                </ListGroup.Item>
                {user !== undefined && user.privilege !== 0 && (
                  <ListGroup.Item action href="#link7" onClick={() => handleActiveTap("admin")}>
                    <b>Admin</b>
                  </ListGroup.Item>
                )}
                {user !== undefined && user.privilege !== 1 && (
                  <ListGroup.Item action href="#link8" onClick={() => handleActiveTap("delete")}>
                    <b>Delete Account</b>
                  </ListGroup.Item>
                )}
              </ListGroup>
            </Col>
            <Col xs={12} sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="#link1">
                  {requirePassword ? passwordFormControll() : editFormControll()}
                </Tab.Pane>
                <Tab.Pane eventKey="#link2">
                  {requirePassword ? passwordFormControll() : editFormControll()}
                </Tab.Pane>
                <Tab.Pane eventKey="#link3">
                  {requirePassword ? passwordFormControll() : editFormControll()}
                </Tab.Pane>
                <Tab.Pane eventKey="#link4">{editFormControll()}</Tab.Pane>
                <Tab.Pane eventKey="#link5">{editFormControll()}</Tab.Pane>
                <Tab.Pane eventKey="#link6">
                  <Form.Label column sm="4"></Form.Label>
                </Tab.Pane>
                <Tab.Pane eventKey="#link7">
                  {passwordFormControll()}
                </Tab.Pane>
                <Tab.Pane eventKey="#link8">
                  {requirePassword ? passwordFormControll() : deleteAccount()}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
          {showMessage && (
            <div
              className={"alert alert-" + responseMessage.cals}
              role="alert"
              style={{
                opacity: showMessage ? 1 : 0,
                transition: "opacity 1s ease-out",
              }}
            >
              {responseMessage.msg}
            </div>
          )}
        </Tab.Container>
      </div>
    </div>
  );
};

export default Settings;